import { Link } from 'react-router-dom';

const footerLinks = {
  视频分类: [
    { label: '日本樱花', to: '/category/japan-sakura' },
    { label: '中国樱花', to: '/category/china-sakura' },
    { label: '延时摄影', to: '/category/timelapse' },
    { label: '旅行Vlog', to: '/category/travel-vlog' },
    { label: '赏樱攻略', to: '/category/viewing-guide' },
  ],
  关于我们: [
    { label: '品牌故事', to: '/about' },
    { label: '联系我们', to: '/about#contact' },
    { label: '用户协议', to: '/about' },
    { label: '隐私政策', to: '/about' },
  ],
  热门推荐: [
    { label: '京都岚山樱花隧道', to: '/article/a001' },
    { label: '中国十大赏樱地', to: '/article/a002' },
    { label: '樱花品种图鉴', to: '/article/a003' },
    { label: '延时摄影入门', to: '/article/a004' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-flower-line text-lg text-background-50"></i>
              </div>
              <span className="font-heading text-lg font-semibold text-foreground-950">
                樱花视频
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              专注樱花主题的高清视频平台，汇聚全球樱花盛开实录、延时摄影、旅行Vlog及赏樱攻略，带你足不出户感受春日浪漫。
            </p>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="font-heading text-sm font-semibold text-foreground-950 mb-4">
                {title}
              </h4>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 樱花视频 YinghuaVideo.com 保留所有权利
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-500 hover:text-primary-600 hover:bg-primary-100 transition-colors" aria-label="微博">
              <i className="ri-weibo-line text-sm"></i>
            </a>
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-500 hover:text-primary-600 hover:bg-primary-100 transition-colors" aria-label="微信">
              <i className="ri-wechat-line text-sm"></i>
            </a>
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-500 hover:text-primary-600 hover:bg-primary-100 transition-colors" aria-label="B站">
              <i className="ri-bilibili-line text-sm"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}